import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pageCaption" }
const _hoisted_2 = { class: "d-flex flex-row gap-1" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FormGridColumn = _resolveComponent("FormGridColumn")!
  const _component_FormGridLocal = _resolveComponent("FormGridLocal")!
  const _component_PlotOrderItemTemplateListWidget = _resolveComponent("PlotOrderItemTemplateListWidget")!
  const _component_Transform = _resolveComponent("Transform")!

  return (_openBlock(), _createBlock(_component_Transform, { transformer: _ctx.formTransformer }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(this.getCaption()), 1),
        _createVNode(_component_FormGridLocal, {
          columns: 2,
          labelWidth: 12
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({ 'row': true, 'g-3': true, 'px-3': true, 'pt-3': true, 'was-validated': _ctx.wasValidated })
            }, [
              _createVNode(_component_FormGridColumn, null, {
                default: _withCtx(() => [
                  (this.plotOrderTemplateId == null)
                    ? (_openBlock(), _createBlock(_component_Select, {
                        key: 0,
                        label: _ctx.$t("plot.template.edit.label.templateResolver"),
                        id: _ctx.$id('templateResolverSelect'),
                        disabled: false,
                        options: this.constructTemplateResolverOptions(),
                        modelValue: this.plotOrderTemplateInfo.templateResolver,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.plotOrderTemplateInfo.templateResolver) = $event)),
                        selectClass: this.templateResolverCss
                      }, null, 8, ["label", "id", "options", "modelValue", "selectClass"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_TextInput, {
                    label: _ctx.$t("general.name"),
                    disabled: false,
                    modelValue: this.plotOrderTemplateInfo.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.plotOrderTemplateInfo.name) = $event)),
                    inputClass: this.nameCss,
                    maxlength: "80"
                  }, null, 8, ["label", "modelValue", "inputClass"]),
                  _createVNode(_component_TextInput, {
                    label: _ctx.$t("general.description"),
                    tag: "textarea",
                    disabled: false,
                    modelValue: this.plotOrderTemplateInfo.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.plotOrderTemplateInfo.description) = $event)),
                    maxlength: "255"
                  }, null, 8, ["label", "modelValue"]),
                  (this.plotOrderTemplateInfo.templateResolver=='REVIEW_CYCLE')
                    ? (_openBlock(), _createBlock(_component_Select, {
                        key: 1,
                        label: _ctx.$t("plot.template.edit.label.basedOnReviewCycle"),
                        id: _ctx.$id('reviewCycleSelect'),
                        disabled: this.plotOrderTemplateId != null,
                        options: this.reviewCycleSelectOptions,
                        modelValue: this.plotOrderTemplateInfo.reviewCycleId,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.plotOrderTemplateInfo.reviewCycleId) = $event)),
                        selectClass: this.reviewCycleCss
                      }, null, 8, ["label", "id", "disabled", "options", "modelValue", "selectClass"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_FormGridColumn, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Select, {
                    label: _ctx.$t("plot.template.prop.billingAddress"),
                    disabled: false,
                    options: this.billingAddressSelectOptions,
                    modelValue: this.plotOrderTemplateInfo.billingAddressId,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.plotOrderTemplateInfo.billingAddressId) = $event)),
                    selectClass: this.billingAddressCss
                  }, {
                    postWidget: _withCtx(({ }) => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-primary",
                          "data-bs-toggle": "tooltip",
                          title: _ctx.$t('plot.template.edit.billing.editToolTip'),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.editBillingAddress(_ctx.item)))
                        }, _hoisted_5, 8, _hoisted_3),
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-outline-secondary",
                          "data-bs-toggle": "tooltip",
                          title: _ctx.$t('plot.template.edit.billing.addToolTip'),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addBillingAddress(_ctx.item)))
                        }, _hoisted_8, 8, _hoisted_6)
                      ])
                    ]),
                    _: 1
                  }, 8, ["label", "options", "modelValue", "selectClass"]),
                  _createVNode(_component_Select, {
                    label: _ctx.$t("plot.template.prop.plotter"),
                    disabled: false,
                    options: this.plotterSelectOptions,
                    modelValue: this.plotOrderTemplateInfo.plotterProjectParticipationId,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.plotOrderTemplateInfo.plotterProjectParticipationId) = $event)),
                    selectClass: _ctx.plotterCss
                  }, null, 8, ["label", "options", "modelValue", "selectClass"]),
                  _createVNode(_component_Select, {
                    label: _ctx.$t("plot.template.prop.kindOfDelivery"),
                    disabled: false,
                    options: this.kindOfDeliverySelectOptions,
                    modelValue: this.plotOrderTemplateInfo.kindOfDelivery,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.plotOrderTemplateInfo.kindOfDelivery) = $event)),
                    selectClass: _ctx.kindOfDeliveryCss
                  }, null, 8, ["label", "options", "modelValue", "selectClass"]),
                  _createVNode(_component_TextInput, {
                    label: _ctx.$t("plot.template.prop.comment"),
                    tag: "textarea",
                    disabled: false,
                    modelValue: this.plotOrderTemplateInfo.comment,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.plotOrderTemplateInfo.comment) = $event)),
                    maxlength: "255"
                  }, null, 8, ["label", "modelValue"])
                ]),
                _: 1
              })
            ], 2)
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          disabled: this.saveDisabled,
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.saveTemplate && _ctx.saveTemplate(...args)))
        }, _toDisplayString(_ctx.$t("general.save")), 9, _hoisted_9),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary m-1",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          disabled: _ctx.disabled
        }, _toDisplayString(_ctx.$t('general.cancel')), 9, _hoisted_10),
        _createVNode(_component_PlotOrderItemTemplateListWidget, {
          plotOrderItemTemplateInfos: this.plotOrderTemplateInfo.items,
          "onUpdate:plotOrderItemTemplateInfos": _cache[12] || (_cache[12] = ($event: any) => ((this.plotOrderTemplateInfo.items) = $event)),
          templateResolver: this.plotOrderTemplateInfo.templateResolver,
          editInfo: this.plotOrderTemplateEditInfo,
          deliveryAddressId: this.deliveryAddressId,
          onAddItem: _ctx.addItem,
          onRemoveItem: _ctx.removeItem
        }, null, 8, ["plotOrderItemTemplateInfos", "templateResolver", "editInfo", "deliveryAddressId", "onAddItem", "onRemoveItem"])
      ])
    ]),
    _: 1
  }, 8, ["transformer"]))
}